import React, { ChangeEvent, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import { InitialState, PageType } from './types'
import moment from 'moment'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'

export default () => {
  const [mounted, setMounted] = useState(false)
  const [pageData, setPageData] = useState<PageType | null>(null)
  const [image, setImage] = useState<File | null>(null)

  const dispatch = useDispatch()
  const { id } = useParams<{ id: string }>()
  const { achievement, isProcessFetching, usersCount, error } = useSelector(
    (state: { adminAchievementEdit: InitialState }) =>
      state.adminAchievementEdit
  )

  const percent = pageData?.user_achievements_count
    ? (pageData.user_achievements_count * 100) / usersCount
    : 0

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchAchievement(id))
    dispatch(actions.fetchUsersCount())
    setMounted(true)
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (achievement) {
      const data: PageType = {}
      data.caption = achievement.caption
      data.code = achievement.code
      data.status = achievement.status
      data.requirements = achievement.requirements
      data.description = achievement.description
      data.share_description = achievement.share_description
      data.image = achievement.image_media?.url
      data.created_at = achievement.created_at
      data.user_achievements_count = achievement.user_achievements_count
      setPageData(data)
    }
  }, [achievement])

  const onChangeCaption = (event: ChangeEvent<HTMLInputElement>) => {
    if (pageData) {
      pageData.caption = event.currentTarget.value
      setPageData({ ...pageData })
    }
  }

  const onChangeRequirements = (event: ChangeEvent<HTMLTextAreaElement>) => {
    if (pageData) {
      pageData.requirements = event.currentTarget.value
      setPageData({ ...pageData })
    }
  }

  const onChangeDescription = (event: ChangeEvent<HTMLTextAreaElement>) => {
    if (pageData) {
      pageData.description = event.currentTarget.value
      setPageData({ ...pageData })
    }
  }

  const onChangeShareDescription = (
    event: ChangeEvent<HTMLTextAreaElement>
  ) => {
    if (pageData) {
      pageData.share_description = event.currentTarget.value
      setPageData({ ...pageData })
    }
  }

  const onChangeImage = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const file = event.target.files[0]
      setImage(file)
    }
  }

  const handleChangeStatus = (event: ChangeEvent<HTMLSelectElement>) => {
    if (pageData) {
      pageData.status = event.currentTarget.value
      setPageData({ ...pageData })
    }
  }

  const handleSaveAchievement = () => {
    const status = pageData?.status
    const caption = pageData?.caption
    const requirements = pageData?.requirements
    const description = pageData?.description
    const shareDescription = pageData?.share_description
    if (status && caption && requirements && description) {
      dispatch(
        actions.editAchievement(
          id,
          status,
          caption,
          requirements,
          description,
          shareDescription,
          image || undefined
        )
      )
    } else {
      alert('Заполните все поля!')
    }
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        {isProcessFetching || !mounted ? (
          <LoadingPage />
        ) : (
          <>
            <h2>Панель администрирования - Редактирование достижения</h2>
            <label>
              <b>Название:</b>
              <br />
              <input
                type={'text'}
                value={pageData?.caption || ''}
                onChange={onChangeCaption}
              />
            </label>
            <br />
            <br />
            <label>
              <b>Code:</b>
              <br />
              <input
                type={'text'}
                value={pageData?.code || ''}
                disabled={true}
              />
            </label>
            <br />
            <br />
            <label>
              <b>Статус:</b>
              <br />
              <select value={pageData?.status} onChange={handleChangeStatus}>
                <option value={'active'}>Активный</option>
                <option value={'inactive'}>Неактивный</option>
              </select>
            </label>
            <br />
            <br />
            <label>
              <b>Условия получения:</b>
              <br />
              <textarea
                style={{ height: 100 }}
                value={pageData?.requirements || ''}
                onChange={onChangeRequirements}
              />
            </label>
            <br />
            <br />
            <label>
              <b>Описание после вручения:</b>
              <br />
              <textarea
                style={{ height: 100 }}
                value={pageData?.description || ''}
                onChange={onChangeDescription}
              />
            </label>
            <br />
            <br />
            <label>
              <b>Описание для Вконтакте:</b>
              <br />
              <textarea
                style={{ height: 100 }}
                value={pageData?.share_description || ''}
                onChange={onChangeShareDescription}
              />
            </label>
            <br />
            <br />
            <b>Изображение:</b>
            {pageData?.image ? (
              <>
                <br />
                <img
                  src={pageData.image}
                  style={{ marginTop: 10, width: 100, height: 100 }}
                />
              </>
            ) : null}
            <br />
            <input
              type={'file'}
              style={{ marginTop: 10 }}
              onChange={onChangeImage}
            />
            <br />
            <br />
            <b>Дата создания: </b> <br />
            {moment(pageData?.created_at).format('LLLL')}
            <br />
            <br />
            <b>Получило пользователей:</b>{' '}
            {pageData?.user_achievements_count || 0} ({percent.toFixed(1)}% от
            общего количества пользователей курса)
            <br />
            <br />
            <button
              onClick={handleSaveAchievement}
              style={{ marginBottom: 30 }}
            >
              Сохранить
            </button>
            <span style={{ color: 'red' }}>{error}</span>
          </>
        )}
      </div>
      <Footer />
    </>
  )
}
